import React from "react";
import { KeepLearningContainer } from "./KeepLearningContainer.component";
import { CommonWidgetContainer } from "../Commons/CommonWidgetContainer.styles";

export type KeepLearningWidgetProps = {
  setIsOpened?: React.Dispatch<React.SetStateAction<boolean>>;
  enabled?:boolean
};

export const KeepLearningWidget = ({
  setIsOpened,
  enabled
}: KeepLearningWidgetProps) => {
  return (
    <CommonWidgetContainer hasSidePadding={ false }>
      <KeepLearningContainer setIsOpened={ setIsOpened } enabled={ enabled } />
    </CommonWidgetContainer>
  );
};
